/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SaleEntityDecorationPage = lazyLoad(
  () => import('./index'),
  module => module.SaleEntityDecorationPage
);
